import { LABELS_MATRIZ_IMPRESION_DEFAULT } from '@/shared/utils/label_matriz_impresion.js';
import { UNIDAD_TRABAJO_DEFAULT } from '@/shared/utils/unidad_trabajo.js';

export const resultado_produccion_model = {
  codigoCotizacion: null,
  isStale: false,
  cantidades: [],
};

export const cantidad_model = {
  codigoCotizacionCantidad: null,
  cantidad: 0,
  fechaCalculo: null,
  producto: {
    desarrollo: 0,
    anchoMinimo: 0,
    anchoMaterial: 0,
    totalBocas: 0,
    bocasAncho: 0,
    bocasDesarrollo: 0,
    m2PorPliego: 0,
    unidadesPorPliego: 0,
    metroPorPliego: 0,
    gramajeTotal: 0,
  },
  cantidadDatos: {
    totalesIniciales: {
      unidades: 0,
      metrosLineales: 0,
      metrosCuadrados: 0,
      kilogramos: 0,
      pliegos: 0,
    },
    totalesConMerma: {
      unidades: 0,
      metrosLineales: 0,
      metrosCuadrados: 0,
      kilogramos: 0,
      pliegos: 0,
    },
    mermaGlobal: {
      porcentaje: 0,
      diferencia: 0,
      cantidadInicial: 0,
      cantidadFinal: 0,
      unidadEvaluada: '',
    },
  },
  procesos: [],
  materiales: [],
};

export const proceso_model = {
  codigoProceso: null,
  codigoCotizacionElementoProceso: null,
  descripcion: '',
  metrosLinealesNetos: 0,
  metrosLinealesBuenos: 0,
  mermaFija: 0,
  unidadMermaFija: null,
  mermaPorcentual: 0,
  mermaFutura: 0,
  mermaTotal: 0,
  metrosTotales: 0,
  horasProduccion: 0,
  horasSetupTotal: 0,
  horasSetupDetalle: {
    ajuste: 0,
    color: 0,
    polimero: 0,
    recarga: 0,
  },
  velocidad: 0,
  velocidadLinea: 0,
  horasTotalesLinea: 0,
  factorVelocidad: 0,
  divideBocas: false,
  factorCortes: 1,
  bocasAncho: 0,
  bocasAlto: 0,
  bocasLargo: 0,
  esImpresion: false,
  // COTI-502: Determinar label para polimero
  labelsMatrizImpresion: { ...LABELS_MATRIZ_IMPRESION_DEFAULT },
  unidadTrabajo: { ...UNIDAD_TRABAJO_DEFAULT },
};

export const material_model = {
  codigoMaterial: null,
  descripcionInterna: '',
  codigoEquivalente: '',
  cantidad: 0,
  cantidadMerma: 0,
  cantidadMermaMinima: 0,
  unidadMedida: '',
  gramaje: 0,
  densidad: 0,
  espesor: 0,
  rendimiento: 0,
  cobertura: 0,
  kilosPorPliego: 0,
  categoria: '',
  esTinta: false,
  esBarniz: false,
};
